import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  .audio-react-recorder,
  audio {
    display: none;
  }
`;

export const Recorder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 15rem;
  max-width: 100%;
  padding: 0.625rem 1rem;
  border: 1px solid var(--gray60);
  border-radius: 4px;
  i {
    height: 1.25rem;
    cursor: pointer;
  }
`;

export const IconRight = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
